import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Paginator} from '../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {ConfirmDirective} from '../../../../../directives/confirm/confirm.directive';
import { DatePipe, NgOptimizedImage } from '@angular/common';
import {PaginatorComponent} from '../../../../layout/paginator/paginator.component';
import {TableSorterHeaderDirective} from '../../../../../directives/table-sorter/table-sorter-header.directive';
import {RouterLink} from '@angular/router';
import {TableSorterDirective} from '../../../../../directives/table-sorter/table-sorter.directive';
import {IsGranted} from '../../../../../decorator/is-granted';
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {News} from '../../../../../models/news';
import {NewsService} from '../../../../../services/news/news.service';
import {ImageService} from '../../../../../services/image/image.service';

@Component({
  selector: 'app-news-list',
  imports: [
    ConfirmDirective,
    PaginatorComponent,
    TableSorterHeaderDirective,
    RouterLink,
    TableSorterDirective,
    IsGrantedDirective,
    DatePipe,
    NgOptimizedImage
],
  templateUrl: './news-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './news-list.component.scss'
})
@IsGranted(['NEWS_VIEW'])
@MetaTitle('GizmO News')
export class NewsListComponent implements OnInit {
  news: News[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'asc');

  constructor(
    protected imageService: ImageService,
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private newsService: NewsService
  ) {
  }

  ngOnInit(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.newsService.findAll({groups: 'image'}, this.paginator, this.tableSorter).subscribe((news) => {
      this.news = news;

      this.loader.stopLoading();
    })
  }

  delete(news: News): void {
    if (news.id) {
      this.loader.startLoading();
      this.newsService.delete(news.id).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('News has been deleted');
        this.fetchAll();
      });
    }
  }
}
